import { VelocityVariable } from '../../domain/enrichment/EnrichmentDomain';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { VelocityVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';
import { StreamJsonModel } from '../../domain/stream/stream/StreamDomain';

export type VelocityVariableActions =
  | 'CHANGE_VELOCITY_VARIABLE'
  | 'CHANGE_VELOCITY_VARIABLE_SCHEMA'
  | 'CHANGE_VELOCITY_VARIABLE_IS_UPDATE'
  | 'CLEAR_VELOCITY_VARIABLE'
  | 'CHANGE_VELOCITY_VARIABLE_DIRTY'
  | 'CHANGE_VELOCITY_VARIABLE_PERMITTED_STORES';

export const changeVelocityVariable = (payload: VelocityVariable | null) =>
  ({
    type: 'CHANGE_VELOCITY_VARIABLE',
    payload,
  }) as ReduxBaseAction<VelocityVariable | null, VelocityVariableActions>;

export const changeVelocityVariableSchema = (payload: VelocityVariableSchema | null) =>
  ({
    type: 'CHANGE_VELOCITY_VARIABLE_SCHEMA',
    payload,
  }) as ReduxBaseAction<VelocityVariableSchema | null, VelocityVariableActions>;

export const changeVelocityVariableIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_VELOCITY_VARIABLE_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, VelocityVariableActions>;

export const clearVelocityVariable = () =>
  ({
    type: 'CLEAR_VELOCITY_VARIABLE',
    payload: void 0,
  }) as ReduxBaseAction<any, VelocityVariableActions>;

export const changeVelocityVariableDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_VELOCITY_VARIABLE_DIRTY',
    payload,
  }) as ReduxBaseAction<any, VelocityVariableActions>;

export const changeVelocityVariablePermittedStores = (stores: Record<string, StreamJsonModel[]>) =>
  ({
    type: 'CHANGE_VELOCITY_VARIABLE_PERMITTED_STORES',
    payload: stores,
  }) as ReduxBaseAction<any, VelocityVariableActions>;
